<template>
    <div class="ppv2-relative ppv2-inline-flex ppv2-group/tooltip" @mouseenter="visible = true" @mouseleave="visible = false">
        <!-- Trigger -->
        <div class="ppv2-flex ppv2-items-center">
            <slot />
        </div>

        <!-- Tooltip -->
        <transition
            enter-active-class="ppv2-transition-all ppv2-duration-200"
            leave-active-class="ppv2-transition-all ppv2-duration-150"
            enter-class="ppv2-opacity-0 ppv2-scale-95"
            enter-to-class="ppv2-opacity-100 ppv2-scale-100"
            leave-class="ppv2-opacity-100 ppv2-scale-100"
            leave-to-class="ppv2-opacity-0 ppv2-scale-95"
        >
            <div
                v-if="visible"
                :class="[tooltipClasses, wrapClasses, themeClasses]"
                :style="bubbleStyle"
                class="ppv2-absolute ppv2-z-[9999] ppv2-text-[11px] poppinsMedium ppv2-px-3 ppv2-py-2 ppv2-rounded-xl ppv2-shadow-[0_8px_30px_rgb(0,0,0,0.12)]"
            >
                {{ text }}

                <!-- Arrow -->
                <div :class="arrowClasses"></div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Tooltip',

    props: {
        text: {
            type: String,
            default: '',
        },

        position: {
            type: String,
            default: 'top', // top | bottom | left | right
        },

        wrap: {
            type: Boolean,
            default: false,
        },

        light: {
            type: Boolean,
            default: false,
        },

        minWidth: {
            type: Number,
            default: 0,
        },

        align: {
            type: String,
            default: 'center', // center | start
        },
    },

    data() {
        return {
            visible: false,
        }
    },

    computed: {
        horizontalAlign() {
            return this.align === 'start' ? 'ppv2-left-0' : 'ppv2-left-1/2 ppv2--translate-x-1/2'
        },

        tooltipClasses() {
            switch (this.position) {
                case 'bottom':
                    return `
                        ppv2-top-full
                        ${this.horizontalAlign}
                        ppv2-mt-3
                    `

                case 'left':
                    return `
                        ppv2-right-full
                        ppv2-top-1/2
                        ppv2--translate-y-1/2
                        ppv2-mr-3
                    `

                case 'right':
                    return `
                        ppv2-left-full
                        ppv2-top-1/2
                        ppv2--translate-y-1/2
                        ppv2-ml-3
                    `

                default:
                    return `
                        ppv2-bottom-full
                        ${this.horizontalAlign}
                        ppv2-mb-3
                    `
            }
        },

        bubbleStyle() {
            return this.minWidth > 0 ? { minWidth: `${this.minWidth}px` } : null
        },

        wrapClasses() {
            return this.wrap ? 'ppv2-whitespace-normal ppv2-max-w-[320px] ppv2-w-max' : 'ppv2-whitespace-nowrap'
        },

        themeClasses() {
            if (this.light) {
                return 'ppv2-bg-white ppv2-text-[#1E1B4B]'
            }
            return 'ppv2-bg-[#1E1B4B] ppv2-text-white'
        },

        arrowClasses() {
            switch (this.position) {
                case 'bottom':
                    return `
                        ppv2-absolute
                        ppv2-bottom-full
                        ppv2-left-1/2
                        ppv2--translate-x-1/2
                        ppv2-border-l-[6px]
                        ppv2-border-r-[6px]
                        ppv2-border-b-[6px]
                        ppv2-border-l-transparent
                        ppv2-border-r-transparent
                        ${this.light ? 'ppv2-border-b-white' : 'ppv2-border-b-[#1E1B4B]'}
                    `

                case 'left':
                    return `
                        ppv2-absolute
                        ppv2-left-full
                        ppv2-top-1/2
                        ppv2--translate-y-1/2
                        ppv2-border-t-[6px]
                        ppv2-border-b-[6px]
                        ppv2-border-l-[6px]
                        ppv2-border-t-transparent
                        ppv2-border-b-transparent
                        ${this.light ? 'ppv2-border-l-white' : 'ppv2-border-l-[#1E1B4B]'}
                    `

                case 'right':
                    return `
                        ppv2-absolute
                        ppv2-right-full
                        ppv2-top-1/2
                        ppv2--translate-y-1/2
                        ppv2-border-t-[6px]
                        ppv2-border-b-[6px]
                        ppv2-border-r-[6px]
                        ppv2-border-t-transparent
                        ppv2-border-b-transparent
                        ${this.light ? 'ppv2-border-r-white' : 'ppv2-border-r-[#1E1B4B]'}
                    `

                default:
                    return `
                        ppv2-absolute
                        ppv2-top-full
                        ppv2-left-1/2
                        ppv2--translate-x-1/2
                        ppv2-border-l-[6px]
                        ppv2-border-r-[6px]
                        ppv2-border-t-[6px]
                        ppv2-border-l-transparent
                        ppv2-border-r-transparent
                        ${this.light ? 'ppv2-border-t-white' : 'ppv2-border-t-[#1E1B4B]'}
                    `
            }
        },
    },
}
</script>
